<template>
  <div>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-banner color="primary" class="mb-6 white--text" shaped single-line>
            Archivos adjuntos
          </v-banner>
          <v-file-input
            v-model="files"
            placeholder="Seleccione los archivos"
            label="Adjuntar archivos"
            multiple
            show-size
            counter
            dense
            accept="image/png, image/jpeg, image/jpg, image/bmp, application/pdf"
            prepend-icon="mdi-paperclip"
          ></v-file-input>
          <v-banner color="primary" class="mb-6 white--text" shaped single-line>
            Formato de escaneo
          </v-banner>
        </v-col>
        <v-col cols="12" sm="6" md="6"
          ><v-banner
            color="primary"
            class="mb-6 white--text"
            shaped
            single-line
          >
            Fotografía
          </v-banner>
          <CameraSuim :videoTypes="['camera']" ref="cameraSUIM" />
        </v-col>
        <v-col v-if="attachmentsData.currentImagenBase64">
          <div class="d-flex flex-column justify-space-between align-center">
            <strong>Fotografía actual</strong>
            <v-img
              max-width="350"
              :src="attachmentsData.currentImagenBase64"
            ></v-img>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-menu
            offset-x
            bottom
            left
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mr-12 mb-4"
                outlined
                color="error"
                depressed
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="laststep()"
              >
                <v-icon left> mdi-keyboard-backspace </v-icon>
                paso anterior
              </v-btn>
            </template>
          </v-menu>
          <v-menu
            offset-x
            bottom
            rigth
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mb-4"
                :disabled="invalid"
                v-bind="attrs"
                depressed
                outlined
                v-on="{ ...menu }"
                color="primary"
                @click="nextstep()"
              >
                Siguiente paso
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
    </validation-observer>
  </div>
</template>

<script>
import CameraSuim from "@/components/CameraSuim.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {
    attachmentsData: Object,
  },
  components: {
    CameraSuim,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      files: undefined,
    };
  },
  mounted() {
    this.$watch(
      "$refs.cameraSUIM.imagenBase64",
      (newValue) => (this.attachmentsData.imagenBase64 = newValue)
    );
  },
  methods: {
    laststep() {
      this.$emit("laststep", 3);
    },
    nextstep() {
      this.$emit("nextstep", 5);
    },
  },
};
</script>
